import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class NewsService {
  constructor(private http: HttpClient) {}

  async getAnnouncement(): Promise<any> {
    return [
      {
        id: 4,
        content: "PrimeBlocks E-Commerce Edition is out now.",
        linkText: "View Demo",
        linkHref: "https://www.primefaces.org/primeblocks-ng/#/ecommerce",
        backgroundStyle: "background-color:#3B82F6",
        textStyle: "color:#ffffff;font-weight:500",
        linkStyle: "color:#ffffff;font-weight:700",
        linkHoverStyle: "text-decoration: underline"
      }
    ];
  }
}
